import React, { Fragment } from "react";

const DiscussionStart = ({ removeParticipant }) => {
  return (
    <Fragment>
      <div className="discussion-start-overlay">
        <div>
          <p className="discussion-start">
            You're up next! Discussion starting in:
          </p>
          <p className="discussion-count green">:60</p>
          <p
            onClick={() => {
              removeParticipant();
            }}
            className="leave-discussion red background-black"
          >
            Click here to leave discussion
          </p>
        </div>
      </div>
    </Fragment>
  );
};

export default DiscussionStart;
